import React from 'react';
import '../Forms/form.css';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import SocialContext from '../../context/SocialContext';
import { CircularProgress } from '@material-ui/core';
import { Alert } from '@mui/material';
import Alertjs from '../../components/alert/Alert';
import Topbar from '../../components/topbar/Topbar';
import axiosInstance from '../../config';

export default function ResetPassword() {
    const navigate = useNavigate();
    useEffect(() => {
        if (localStorage.getItem('currentUID')) {
            navigate('/');
        }
        scrolltoTopfun();
        window.document.title = 'SocialHub - Reset Password';
    }, [])

    const { showalert, setshowalert, setalertType, setalertmessage, scrolltoTopfun } = useContext(SocialContext);
    const [email, setemail] = useState('');
    const [showmessage, setshowmessage] = useState(false);
    const [message, setmessage] = useState('');
    const [isfetching, setisfetching] = useState(false);

    const sendfun = async () => {
        document.getElementById('sendbtn').disabled = true;
        try {
            setisfetching(true);
            const response = await axiosInstance.post('api/auth/sendpasswordlink', { email });
            if (response.status == 201) {
                setemail("");
                setmessage("Password reset link Succsfully sent to your email");
                setshowmessage(true);
                setshowalert(true);
                setalertType('success');
                setalertmessage("Password reset link sent to your email");
                setTimeout(() => {
                    setshowalert(false);
                }, 2000);
            } else {
                setshowalert(true);
                setalertType('warning');
                setalertmessage("Invalid User");
                setmessage("Invalid User");
                setshowmessage(true);
                setTimeout(() => {
                    setshowmessage(false);
                }, 2000);
                setTimeout(() => {
                    setshowalert(false);
                }, 2000);
                setemail("");
            }
            setisfetching(false);
        } catch (error) {
            console.log("error inside login fun", error);
        }
        document.getElementById('sendbtn').disabled = false;
    }



    // login
    const onsubmitfun = (event) => {
        event.preventDefault();
        if (email !== "") {
            sendfun();
            setTimeout(() => {
                setemail("");
            }, 2000);
        } else {
            sendfun();
        }
    }

    const onclickfun = () => {
        if (email === "") {
            setshowalert(true);
            setalertType('warning');
            setalertmessage("Please enter login credentials and try again..");
            setTimeout(() => {
                setshowalert(false);
            }, 2000);
        }
    }

    return (
        <>
            <Topbar />
            {showalert ? <div style={{ 'position': 'sticky', 'top': '50px', 'zIndex': '2' }}>
                <Alertjs />
            </div> : ""}
            <div className="back">
                <div className='formbody'>
                    <div className="sign-up-form">
                        <h1>Enter Your Email</h1>
                        {showmessage ? <p style={{ color: 'green', fontWeight: 'bold' }}>{message}</p> : ''}
                        <form onSubmit={onsubmitfun}>
                            <p className='formtitle'>Email*</p>
                            <input value={email} onChange={(e) => { setemail(e.target.value) }} required autoComplete='off' name="email" type="email" className='input-box' placeholder='Your Email' />
                            <button type='submit' id='sendbtn' onClick={onclickfun} className='formbutton signup-btn'>{isfetching ? <CircularProgress size="17px" /> : "Send"}</button>
                        </form>
                        <hr className='formhr' />
                        <p className='p'>Back ? <Link style={{ 'textDecoration': 'none' }} to="/register">  Click Here</Link></p>
                    </div>
                </div>
                <div className="copyright" style={{'position':'fixed','bottom':'1px','width':'100%'}}>
                    <p style={{ 'textAlign': 'center', opacity: '0.9','width':'100%' }}>Copyright ©2022-Alok.info | All rights reserved</p>
                </div>
            </div>
        </>
    );
}
